module.exports = "<div class=\"q-pill {%- statusPillClass %} q-stretch\"> {%- statusText %} </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/order/html/statusPill.html
// module id = 299
// module chunks = 1